export interface ActionItemCountData {
  actionItemName: string;
  count: number;
}
